import React from "react";

import axios2 from 'services/axios2';

import {useParams} from "react-router-dom";
import {Link,hashHistory} from 'react-router-dom';
import { ToastContainer, toast } from 'react-toastify';
import { NuDropdown } from "../../components/nubox/NuDropdown";
import { withRouterJim } from "router/withRouterJim";

import NuConfirm from "components/nubox/Box/NuConfirm";
import ModalCitaHora from "views/CitaHora_crud/ModalCitaHora"


import user from 'assets/img/user.jpg';

import { NotificationContainer, NotificationManager } from 'react-notifications';
import {
  Table,
  Button,
  Container,
  Modal,
  ModalHeader,
  ModalBody,
  FormGroup,
  ModalFooter,
  ToastHeader,
} from "reactstrap";

const data = [
  { id_u: 1,  nomape: "ALEX LIZARRAGA",  especialidad: "00000023",tel:''},
  { id_u: 2,  nomape: "MARIANELA",  especialidad: "00000023",tel:''},
 
];

/*$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$*/
class CitaHora_crud extends React.Component {  

  modalRef = React.createRef();//create ref
  
  state = {
    modalInsertar: false,
    form: {
      name: 0,
    },
    data: data,/* lista de datos */
    
  };
   //--------------------------------------
   constructor(props) {
    super(props);

    this.refNuConfirm = React.createRef();
  }
  //------------------
  //------------------------------------------------------
  componentDidMount() {
    //--limpiamos el array de prueba
    this.setState({data:[]});

   
    let id = this.props.params.id;
    console.log(this.props.params);
    
    this.setState({ id_u: id });
    //this.cargar_citas();
    this.cargar_data(id);

  }

  //------------ cambiamos la fecha
  /*handleChange = event =>{
    this.setState({ name: event.target.value});
  }*/
  //----------------especial, actualiza valores del form -------------------------------
  handleChangeForm = (e) => {
    //requerimos la prop name="?" en cada control
    this.setState({
      form: {
        ...this.state.form,
        [e.target.name]: e.target.value,
      },
    });
  };
  
  //====================================================== 
  //----cargamos los datos desde la base de datos
  /*{
      "id_u": 1,
      "nomape": "Dr. Gerson Abner Villafuerte Oporto",
      "dir": "",
      "tel": "",
      "cel": "",
      "foto_path1": ""
      "especialidad": "Ortodoncia"
  },*/
  cargar_data = (id_u) => {
    let param = { 
      id_u: id_u,
    }
    console.log(param);

    axios2.post("citahora_lista", param)
    .then(res => {
        if(res.data.length>0){ 
            //NotificationManager.success("Correcto");
            this.setState({data: res.data});
            //console.log(this.state.medicos);
        }else{
            NotificationManager.error("No existen datos");
        }

    }).catch(error => {
        alert("---- Existio un error ---");
        console.log(error);
        
    });
  };
      
  imprimir =(id_certi)=>{
    let fileURL = process.env.REACT_APP_API_URL  + "certificado_reciboPDF/"+ id_certi;
    let  windowFeatures = 'width=650,height= 700, left=100,top=100 ';
    window.open(fileURL,'',windowFeatures);
  }
  //----------------
  
  /* === This is where the magic happens ==== */
  handleSubmit = event => {
    event.preventDefault();
    this.cargar_data();
  }
  /************************************************ */
  nuevo = () => {
    
    this.modalRef.current.nuevo();
    //this.setState({ modalInsertar: true});
  }
  /************************************************************** */
  editar = (item) =>{
    console.log("editar");
    //    console.log(item);
    let idd = item.id_u; //id_medic
    this.modalRef.current.editar(idd);
  }
  eliminar = (item) =>{
    console.log("eliminar");
    console.log(item);
    //--------------------------------
    this.refNuConfirm.current.show({
      message: 'Esta seguro de eliminar?',
      title: 'Confirmar',
      icon: 'fa fa-question-circle',
      classHeader: 'bg-default1 ',
      classButton: 'btn btn-danger',
      accept: () => {
        let idd = item.id_u;
        this.modalRef.current.eliminar(idd);
      },
      reject: () => {
          console.log('cancel');
      },
      acceptLabel: 'Aceptar',
      rejectLabel: 'Cancelar'
    })

  }
  //---------------------------------------------
  okModal =()=>{
    console.log("citaOkModal");
    this.cargar_data();
  }
  //---------------------------------------------
  closeModal =()=>{
    console.log("citaCancelModal");
  }
  //-------------------------------------
  render() {
    
    return (
      <div>
        <ToastContainer />
        <div className="content">
          { this.state.id_u }
          {/*<!--- ------------------------------->*/}
          <div className="row">
            <div className="col-md-7">
              <h3> Horas de trabajo
                <div className="btn-group pull-right">

                  <Button onClick={()=> this.nuevo() } className="create-modal btn btn-success " >
                    <i className="fa fa-plus"></i> Nuevo
                  </Button>
                </div>
              </h3>


         

              {/*<!-- box table -->*/}
              <div className="box box-info">
                <div className="box-header">
                  <br/>
                    <div className="">


                      <div className="table-responsive">
                        <table className="table tabla_azul0 table-striped table-hover ">
                          <thead>
                            <tr>
                            
                              <th>Cod.Hora</th>
                              <th>Hora</th>
                              <th>Medico</th>
                              
                              <th className="text-center" style={{ width:"150px" }}>Acción</th>
                            </tr>
                          </thead>
                          <tbody>

                            {this.state.data.map((item, index) => (
                              <tr key={index}>
                                <td>{ item.id_citaho } </td>
                                <td>{ item.hora } </td>
                                <td>{item.nomape} </td>

                                <td style={{textAlign:"center"}}>
                                  <div className="btn-group" >
                                    <Button  className="btn btn-warning btn-sm" title="Editar" onClick={ ()=> this.editar(item) }>
                                      <i className="fa fa-edit"></i>
                                    </Button>
                                    &nbsp;
                                    <Button className="btn btn-danger btn-sm" title="Eliminar" onClick={ ()=> this.eliminar(item) }  >
                                      <i className="fa fa-trash"></i> 
                                    </Button>
                                  </div>
                                </td>
                              </tr>
                            ))}
                             

                          </tbody>
                          
                          </table>
                        <div className="pull-left">

                        </div>
                      </div>

                    </div>


                </div>
              </div>
              {/*<!-- fin box table -->*/}

            </div>

          </div>
          {/*<!--- ----------------- form busqueda ------------------>*/}

          {/*<!-- -------------------------------------------------->*/}

        </div>


        
        <ModalCitaHora 
            ref={this.modalRef}
            okModal={ this.okModal}
            closeModal={ this.closeModal}
        />
        <NuConfirm   ref={ this.refNuConfirm }    />
      </div>
    );
  }
}
  
//------------para que soporte la funcionalidad de parametros
export default withRouterJim(CitaHora_crud);